import { Grid, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { ILinkTile } from '../Interfaces/ILinkTile';

const useTileStyle = makeStyles({
  root: {
    border: '1px solid #06c',
    color: '#4d4f51',
    '&:hover': {
      backgroundColor: '#06c',
    },
    '&:focus': {
      backgroundColor: '#06c',
    },
  },
  link: {
    width: '140px',
    height: '140px',
    padding: '20px 5px 5px',
    textDecoration: 'none',
    overflow: 'hidden',
    color: '#4d4f51',
    '&:hover': {
      color: 'white',
    },
    '&:focus': {
      color: 'white',
      backgroundColor: '#06c',
    },
  },
  linkText: {
    color: 'inherit',
    fontWeight: 700,
    lineHeight: 1.2,
    margin: '5px 0 0 0',
  },
});

const LinkTile = (props: ILinkTile) => {
  const tileStyle = useTileStyle();
  const inner = (
    <>
      <Grid item container justifyContent="center">
        {props.children}
      </Grid>
      <Grid item container justifyContent="center">
        <Typography
          align="center"
          variant="subtitle2"
          className={tileStyle.linkText}
          // style={{ color: 'inherit', fontWeight: 700 }}
        >
          {props.text}
        </Typography>
      </Grid>
    </>
  );
  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      alignContent="center"
      className={tileStyle.root}
    >
      {props.to && (
        <Link to={props.to} className={tileStyle.link}>
          {inner}
        </Link>
      )}
      {props.href && !props.to && (
        <a href={props.href} className={tileStyle.link}>
          {inner}
        </a>
      )}
    </Grid>
  );
};

export default LinkTile;
